import _defineProperty from '@babel/runtime/helpers/defineProperty';
import components from './components/index.js';
import foundations from './foundations/index.js';
import layerStyles from './layerStyles/index.js';
import textStyles from './textStyles/index.js';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var theme = _objectSpread(_objectSpread({
  config: {
    cssVarPrefix: 'hg',
    useSystemColorMode: false,
    initialColorMode: 'light'
  },
  styles: {
    global: function global() {
      return {
        body: {
          fontFamily: 'body',
          color: 'gray.500',
          bg: 'white',
          lineHeight: 'base'
        },
        '*::placeholder': {
          color: 'gray.300'
        }
      };
    }
  },
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  components: components,
  layerStyles: layerStyles,
  textStyles: textStyles
}, foundations), {}, {
  direction: 'ltr'
});
var theme$1 = theme;
export { theme$1 as default };